import { render } from "./HealthcareHome.vue?vue&type=template&id=5c27d8ac&scoped=true"
import script from "./HealthcareHome.vue?vue&type=script&lang=js"
export * from "./HealthcareHome.vue?vue&type=script&lang=js"

import "./HealthcareHome.vue?vue&type=style&index=0&id=5c27d8ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c27d8ac"]])

export default __exports__